import { apiServer } from 'settings/web-services/api';

export function getAllPromotionsByVendor() {
  return apiServer.get('/partner/promotions');
}

export function createPromotionByVendor(cfg) {
  return apiServer.post('/partner/promotions', cfg);
}

export function getPromotionById(id) {
  return apiServer.get(`/partner/promotions/${id}`);
}

export function updatePromotionById(id, cfg) {
  return apiServer.put(`/partner/promotions/${id}`, cfg);
}

export function deletePromotionById(id) {
  return apiServer.delete(`/partner/promotions/${id}`);
}
